export const CORE_API = 'https://core.uniteus.io/v1/';
export const LEGACY_API_URL = 'https://api.uniteus.io';
export const CORE_LEGACY_API_URL = 'https://core.uniteus.io/legacy/';
export const SERVER_URL = 'https://widgets.uniteus.io/';
export const AWS_DOC_URL = 'https://s3.amazonaws.com/documents.uniteus.io/';
export const FL_PROVIDER_ID = 'e37fe4a2-b5d9-4283-ac7f-81de64748ad1,e3def2b6-0942-4389-9956-0b62511f99a6';
